import { StandardEvents } from '@shopify/events';

/**
 * Keeps the custom SatPhone header cart badge in sync with Horizon's standard
 * cart events. Product-page and collection quick-add flows both emit this
 * event after Shopify confirms the cart mutation.
 */
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise
    ?.then(({ cart, detail }) => {
      const itemCount = cart?.totalQuantity ?? detail?.itemCount;

      if (typeof itemCount !== 'number') return;

      document.querySelectorAll('.sps-cart').forEach((cartLink) => {
        let badge = cartLink.querySelector('.sps-cart__count');

        if (itemCount === 0) {
          badge?.remove();
          return;
        }

        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'sps-cart__count';
          cartLink.appendChild(badge);
        }

        badge.textContent = String(itemCount);
      });
    })
    .catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[sps-cart-count] Cart update failed:', error);
    });
});
